import { jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { connect } from "react-redux";
import { FormName, formValueSelector } from "redux-form";
const tgFormValues = (...fieldNames) => (Component) => (props) => {
  return /* @__PURE__ */ jsx(FormName, { children: (formName) => {
    const name = formName.form;
    const Wrapped = useMemo(() => {
      const selector = formValueSelector(name || "");
      const wrapper = connect((state) => {
        const vals = {};
        fieldNames.forEach((name2) => {
          vals[name2] = selector(state, name2);
        });
        return vals;
      });
      return wrapper(Component);
    }, [name]);
    return /* @__PURE__ */ jsx(Wrapped, { ...props });
  } });
};
export default tgFormValues;
export const tgFormValueSelector = (formName, ...fields) => {
  return connect((state) => {
    return formValueSelector(formName)(state, ...fields);
  });
};
